const initialState = { mentionedNewEmail: '', workspaceId: null };

export default function optionsForInviteToWorkspaceModal(state = initialState, action) {
  switch (action.type) {
    case 'SET_OPTIONS_FOR_INVITE_TO_WORKSPACE_MODAL':
      return action.payload;
    case 'RESET_OPTIONS_FOR_INVITE_TO_WORKSPACE_MODAL':
      return initialState;
    default:
      return state;
  }
}
